import { DialogContent, Stack } from "@mui/material";

import { ContainerLoader } from "@/components/ui-v2/ContainerLoader/ContainerLoader";

import { useFilePickerState } from "../../state";
import { Category } from "../../types";
import { Drive } from "./components/Drive/Drive";
import { FilePickerTabs } from "./components/FilePickerTabs/FilePickerTabs";
import { Poser } from "./components/Poser/Poser";
import { Recent } from "./components/Recent/Recent";

interface FilePickerContentProps {
  categories: Category[];
}

export const FilePickerContent = (props: FilePickerContentProps) => {
  const { categories } = props;
  const { category, isUploading } = useFilePickerState();

  const currentCategory = category || categories[0];

  if (isUploading) {
    return <ContainerLoader />;
  }

  return (
    <Stack direction="row" sx={{ flex: 1, minHeight: 0 }}>
      <FilePickerTabs value={currentCategory} categories={categories} />
      <DialogContent sx={{ flex: 1, overflow: "auto", p: 0 }}>
        {currentCategory === "recent" && <Recent />}
        {currentCategory === "pose" && <Poser />}
        {currentCategory === "drive" && <Drive />}
      </DialogContent>
    </Stack>
  );
};
